module.exports = __webpack_public_path__ + "statics/img/cate7-1@2x.30017bbb.png";